module.exports = __webpack_public_path__ + "static/img/immortal 3.13326fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/immortal 3.png
// module id = 5XBX
// module chunks = 35